import {useEffect, useState} from 'react';

import standaloneConfigService from '../config/standaloneConfig/standaloneConfigService';

const useStandaloneConfig = () => {
    const [standaloneConfig, setStandaloneConfig] = useState(null);

    useEffect(() => {
        const getConfig = async () => {
            const config = await standaloneConfigService.getStandaloneConfig();

            setStandaloneConfig(config);
        };

        getConfig();
    }, []);

    return standaloneConfig;
};

export default useStandaloneConfig;
